module.exports = __webpack_public_path__ + "static/media/loader.ec1e39a2.svg";